import { render, staticRenderFns } from "./admissionsViewRep.vue?vue&type=template&id=31b01525&"
import script from "./admissionsViewRep.vue?vue&type=script&lang=js&"
export * from "./admissionsViewRep.vue?vue&type=script&lang=js&"
import style0 from "./admissionsViewRep.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports